
import './style.less'

import { h, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import classnames from 'classnames'

import { withHydration } from '@util/hydrate'
import Burger from '@components/burger'


const SiteNav = ({ open, links = [] }) => {

	const [menuOpen, setMenuOpen] = useState(!!open)
	const [dropdownOpen, setDropdownOpen] = useState(null)

	useEffect(() => {
		if (menuOpen) window.scrollTo({ top: 0, behavior: 'smooth' })
			document.documentElement.classList[menuOpen ? 'add' : 'remove']('site-nav--no-scroll')
	}, [menuOpen])

	return (
		<div>
			<button class="site-nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
				<span class="site-nav-toggle__burger">
					<Burger open={menuOpen}></Burger>
				</span>
				<span class="site-nav-toggle__inner">{menuOpen && 'Close' || 'Menu'}</span>
			</button>
			<nav class={menuOpen ? 'site-nav site-nav--open' : 'site-nav' }>
				<ul class="site-nav__list">
					{links.map(link => {
						const classes = classnames(
							'site-nav__listitem',
							link.id === dropdownOpen ? 'site-nav__listitem--open' : ''
						)

						function clickHandler(e) {
							if (!link.children.length) return
							e.preventDefault()
							if (dropdownOpen === link.id) {
								setDropdownOpen(null)
							} else {
								setDropdownOpen(link.id)	
							}
						}

						return <li class={classes}>
							<a onClick={clickHandler} target={link.target} class="site-nav__link" href={link.href}>
								<span class="site-nav__link__inner">
									{link.text}
									{link.children.length && <span class="site-nav__link__arrow">
										<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1 1L9 9L17 1" stroke="white"/>
										</svg>
									</span> || ''}
								</span>
							</a>
							{link.children.length && <>
								<ul class="site-nav-dropdown">
									{link.children.map(child => <>
										<li class="site-nav-dropdown__item">
											<a target={child.target} class="site-nav-dropdown__link" href={child.href}>
												<span class="site-nav-dropdown__link__inner">{child.text}</span>
											</a>
										</li>
									</>)}
								</ul>
							</> || ''}
						</li>
					})}
				</ul>
			</nav>
		</div>
	)
}


export default withHydration(SiteNav)



